import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../../AlertBox";
import { RequiredAsterisk } from "../../FormHelper";
import { createFramedPool } from "../../../api/infrastructure";

export default function ModalCreateFramedPool({ show, onClose, onSuccess }) {
  const [form, setForm] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const handleClose = () => {
    setForm({ name: "" });
    setAlert({ show: false, message: "", type: "" });
    onClose();
  };

  const submitData = (event) => {
    event.preventDefault();
    sendCreateFramedPool(form);
  };

  const sendCreateFramedPool = async (form) => {
    setLoading(true);
    try {
      const { data } = await createFramedPool(form);
      onSuccess(data.message);
      handleClose();
    } catch (error) {
      let message = error.response?.data?.message || "Something Error Happened";
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={submitData}>
        <Modal.Header closeButton>
          <Modal.Title>Buat Framed Pool Baru</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="form-group">
            <label>
              Name <RequiredAsterisk />{" "}
            </label>
            <input
              type="text"
              className="form-control"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button type="submit" disabled={loading} className="btn btn-primary">
            {loading ? "Creating..." : "Create Framed Pool"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
